export const CTRL = 'ctrl';

export const SHIFT = 'shift';

export const enum KeyCodes {
    delete = 'Delete',
    addNP = 'NumpadAdd',
    minusNP = 'NumpadSubtract',
    minus = 'Minus',
    equal = 'Equal',
    shiftL = 'ShiftLeft',
    shiftR = 'ShiftRight',
    ctrlL = 'ControlLeft',
    ctrlR = 'ControlRight',
    altL = 'AltLeft',
    altR = 'AltRight',
    alt = 'Alt',
    tab = 'Tab',
    esc = 'Escape',
    backSpace = 'Backspace',

    b0 = 'Digit0',
    b1 = 'Digit1',
    b2 = 'Digit2',
    b3 = 'Digit3',
    b4 = 'Digit4',
    b5 = 'Digit5',
    b6 = 'Digit6',
    b7 = 'Digit7',
    b8 = 'Digit8',
    b9 = 'Digit9',

    np0 = 'Numpad0',
    np1 = 'Numpad1',
    np2 = 'Numpad2',
    np3 = 'Numpad3',
    np4 = 'Numpad4',
    np5 = 'Numpad5',
    np6 = 'Numpad6',
    np7 = 'Numpad7',
    np8 = 'Numpad8',
    np9 = 'Numpad9',

    a = 'KeyA',
    b = 'KeyB',
    c = 'KeyC',
    d = 'KeyD',
    e = 'KeyE',
    f = 'KeyF',
    g = 'KeyG',
    h = 'KeyH',
    i = 'KeyI',
    j = 'KeyJ',
    k = 'KeyK',
    l = 'KeyL',
    m = 'KeyM',
    n = 'KeyN',
    o = 'KeyO',
    p = 'KeyP',
    q = 'KeyQ',
    r = 'KeyR',
    s = 'KeyS',
    t = 'KeyT',
    u = 'KeyU',
    v = 'KeyV',
    w = 'KeyW',
    x = 'KeyX',
    y = 'KeyY',
    z = 'KeyZ',
}

export const enum EmitReturn {

    NEW_DRAWING = 'newDrawing',
    SAVE_DRAWING = 'saveDrawing',
    OPEN_DRAWING = 'openDrawing',
    EXPORT_DRAWING = 'exportDrawing',

    PENCIL = 'pencil',
    BRUSH = 'brush',
    APPLICATEUR = 'applicateur',
    BUCKET_FILL = 'bucket',
    PIPETTE = 'pipette',
    RECTANGLE = 'rectangle',
    ELLIPSE = 'ellipse',
    POLYGON = 'polygon',
    LINE = 'line',
    SELECTION = 'selection',
    PEN = 'pen',
    ERASER = 'eraser',
    TEXT = 'text',
    SPRAY = 'spray',
    FEATHER = 'feather',

    COPY = 'copy',
    PASTE = 'paste',
    CUT = 'cut',
    DUPLICATE = 'duplicate',
    DELETE = 'delete',
    SELECTALL = 'selectall',

    CONTROL_GRID = 'controlGrid',
    CONTROL_MAGNETISM = 'controlMagnetism',
    ADD5_GRID = 'add5Grid',
    SUB5_GRID = 'sub5Grid',

    UNDO = 'undo',
    REDO = 'redo',
}
